import { defaultDirection } from "../constants/defaultValues";

export const getDirection = () => {
    let direction = defaultDirection;
    if (localStorage.getItem("direction")) {
      const localValue = localStorage.getItem("direction");
      if (localValue === "rtl" || localValue === "ltr") {
        direction = localValue;
      }
    }
    return {
      direction,
      isRtl: direction === "rtl"
    };
};

export const flCapital = s => s = s.charAt(0).toUpperCase() + s.slice(1);

export const doProvince = (a) => {
  var prov = null;
  if (String(a).substr(0,2) === "10") {
    prov = "NL"
  } else if (String(a).substring(0,2) === "11") {
    prov = "PE"
  } else if (String(a).substring(0,2) === "12") {
    prov = "NS"
  } else if (String(a).substring(0,2) === "13") {
    prov = "NB"
  } else if (String(a).substring(0,2) === "24") {
    prov = "QC"
  } else if (String(a).substring(0,2) === "35") {
    prov = "ON"
  } else if (String(a).substring(0,2) === "46") {
    prov = "MB"
  } else if (String(a).substring(0,2) === "47") {
    prov = "SK"
  } else if (String(a).substring(0,2) === "48") {
    prov = "AB"
  } else if (String(a).substring(0,2) === "59") {
    prov = "BC"
  } else if (String(a).substring(0,2) === "60") {
    prov = "YT"
  } else if (String(a).substring(0,2) === "61") {
    prov = "NT"
  } else {
    prov = "NU"
  }  
  return prov;
}

export const provinceNameToShort = (a) => {
  var prov = null;
  if (String(a).toLowerCase() === 'ontario') {
    prov = "ON"
  } else if (String(a).toLowerCase() === 'quebec') {
    prov = "QC"
  } else if (String(a).toLowerCase() === 'manitoba') {
    prov = "MB"
  } else if (String(a).toLowerCase() === 'saskatchewan') {
    prov = "SK"
  } else if (String(a).toLowerCase() === 'alberta') {
    prov = "AB"
  } else if (String(a).toLowerCase() === 'british columbia') {
    prov = "BC"
  } else if (String(a).toLowerCase() === 'new brunswick') {
    prov = "NB"
  } else if (String(a).toLowerCase() === 'nova scotia') {
    prov = "NS"
  } else if (String(a).toLowerCase() === 'prince edward island') {
    prov = "PE"
  } else if (String(a).toLowerCase() === 'newfoundland and labrador') {
    prov = "NL"
  } else if (String(a).toLowerCase() === 'northwest territories') {
    prov = "NT"
  } else if (String(a).toLowerCase() === 'yukon') {
    prov = "YT"
  } else {
    prov = "NU"
  }  
  return prov;
}

export const provinceShortToLong = (a) => {
  var prov = null;
  if (String(a).toLowerCase() === 'on') {
    prov = "Ontario"
  } else if (String(a).toLowerCase() === 'qc') {
    prov = "Quebec"
  } else if (String(a).toLowerCase() === 'mb') {
    prov = "Manitoba"
  } else if (String(a).toLowerCase() === 'sk') {
    prov = "Saskatchewan"
  } else if (String(a).toLowerCase() === 'ab') {
    prov = "Alberta"
  } else if (String(a).toLowerCase() === 'BC') {
    prov = "British Columbia"
  } else if (String(a).toLowerCase() === 'NB') {
    prov = "New Brunswick"
  } else if (String(a).toLowerCase() === 'NS') {
    prov = "Nova Scotia"
  } else if (String(a).toLowerCase() === 'PE') {
    prov = "Prince Edward Island"
  } else if (String(a).toLowerCase() === 'NL') {
    prov = "Newfoundland and Labrador"
  } else if (String(a).toLowerCase() === 'NT') {
    prov = "Northwest Territories"
  } else if (String(a).toLowerCase() === 'YT') {
    prov = "Yukon"
  } else {
    prov = "Nunavut"
  }  
  return prov;
}

export const doReOrder = (b) => {
  console.log(b);
  console.log([[b[0][0],b[0][1]],[b[1][0],b[1][1]]])
  return [[b[0][0],b[0][1]],[b[1][0],b[1][1]]];
}

export const getSortedKeys = (obj) => {
  var keys = Object.keys(obj);
  return keys.sort(function(a,b){return obj[b]-obj[a]});
}

export function compare(a, b) {
  if (a.val > b.val) return -1;
  if (a.val < b.val) return 1;
  return 0;
}
